/** Email messaging adapter — STUB (SendGrid / Resend / vendor-agnostic). Implements MessagingPort. */
export function createEmailMessaging() {
  return {
    async availableChannels() { return ["email"]; },
    async channelStatus() { return { status: "not_connected" }; },
    async send() { throw new Error("EMAIL_ADAPTER_NOT_IMPLEMENTED"); },
  };
}
